import { useState, useEffect } from 'react';
import Home         from './pages/Home';
import Login        from './pages/Login';
import LoadingScreen from './components/common/LoadingScreen';
import { getToken, removeToken, fetchMe } from './api/api';

function App() {
  const [user,    setUser]    = useState(null);
  const [checked, setChecked] = useState(false);  // vrai dès qu'on a vérifié le token initial
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Vérifie le token stocké au chargement
  useEffect(() => {
    const token = getToken();

    if (!token) {
      setChecked(true);
      return;
    }

    fetchMe()
      .then(res => {
        if (res.success) {
          setUser(res.user);
        } else {
          removeToken();
        }
      })
      .catch(() => {
        removeToken();
      })
      .finally(() => {
        setChecked(true);
      });
  }, []);

  // Écoute les changements d'URL
  useEffect(() => {
    const handler = () => setCurrentPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  function navigateTo(path) {
    window.history.pushState({}, '', path);
    setCurrentPath(path);
  }

  function handleLoginSuccess(userData) {
    setUser(userData);
    setCurrentPath('/');
  }

  function handleLogout() {
    removeToken();
    setUser(null);
  }

  // Attends la vérification avant d'afficher quoi que ce soit
  if (!checked) {
    return <LoadingScreen />;
  }

  // Non authentifié → page de login
  if (!user) {
    return <Login onSuccess={handleLoginSuccess} />;
  }

  // Authentifié → dashboard
  if (currentPath === '/' || currentPath === '') {
    return <Home navigateTo={navigateTo} user={user} onLogout={handleLogout} />;
  }

  // 404
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100vh', gap: '1rem',
      color: 'var(--text-secondary)',
    }}>
      <h1 style={{ color: 'var(--text)', fontSize: '1.5rem' }}>404</h1>
      <p>Page introuvable</p>
      <button
        onClick={() => navigateTo('/')}
        style={{
          padding: '8px 20px', borderRadius: 'var(--radius-md)',
          background: 'var(--accent-dim)', border: '1px solid var(--accent-glow)',
          color: 'var(--accent-light)', fontWeight: 600, cursor: 'pointer',
        }}
      >
        Retour au dashboard
      </button>
    </div>
  );
}

export default App;
